module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-horizontal-end.c61b19cf.png";